<template>
  <b-container fluid>
    <b-row>
      <b-col style="padding: 1rem">
        提供周年性及季節性果品生產預測、主要是切花生生產預測、蔬菜生產預測、裡作雜糧生產預測及蔬菜生產預測等。
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 1rem">
      <b-col>
        <b-button class="white-text-btn blue" @click="changeCategory(0)"
          >雜糧</b-button
        >
        <b-button class="white-text-btn orange" @click="changeCategory(1)"
          >果品</b-button
        >
        <b-button class="white-text-btn green" @click="changeCategory(2)"
          >蔬菜</b-button
        >
        <b-button class="white-text-btn purple" @click="changeCategory(3)"
          >切花</b-button
        >
        <b-form-input
          class="farminput"
          v-model="object.table.filter"
          placeholder="請輸入作物關鍵字查詢"
          debounce="500"
          max="10"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          ref="croptable"
          :items="object.table.items"
          :fields="object.table.fields"
          :current-page="object.table.currentPage"
          :per-page="object.table.perPage"
          :filter="object.table.filter"
          :busy="object.table.isBusy"
          @filtered="onFiltered"
          sort-by="UPDATE_DATE"
          :sort-desc="true"
          :stacked="ifstacked"
          head-variant="dark"
          responsive
          striped
          hover
        >
          <template #head(CATEGORY)="data">
            <div style="min-width: max-content;">{{ data.label }}</div>
          </template>
          <template #cell(UPDATE_DATE)="data">
            {{ parseDate(data.item.UPDATE_DATE) }}
          </template>
          <template #cell(DESCRIBE)="data">
            <div>
              {{ showdescription(data.item) }}
              <b-link
                v-if="data.item.ifshow"
                style="color: rgb(2,167,240); cursor: pointer;"
                @click="linkClick(data.item)"
                >...收合</b-link
              >
              <b-link
                v-else
                style="color: rgb(2,167,240); cursor: pointer;"
                @click="linkClick(data.item)"
                >...詳情</b-link
              >
            </div>
          </template>
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="object.table.currentPage"
          :total-rows="totalData"
          :per-page="object.table.perPage"
          small
        ></b-pagination>
      </b-col>
      <b-col cols="auto">
        <span>共 {{ totalData }}筆資料，每頁顯示</span>
      </b-col>
      <b-col cols="auto">
        <b-form-select
          v-model="object.table.perPage"
          :options="object.table.pageoptions"
          style="min-width: max-content;"
          size="sm"
        ></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>資料來源：農糧署</b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      object: {
        index: 0,
        name: this.data.name,
        table: {
          fields: [
            {
              key: "UPDATE_DATE",
              label: "更新日期",
            },
            {
              key: "CATEGORY",
              label: "作物分類",
            },
            {
              key: "DESCRIBE",
              label: "內容描述",
            },
          ],
          items: [],
          list1: [],
          list2: [],
          list3: [],
          list4: [],
          allitems: [],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          isBusy: true,
          pageoptions: [10, 50, 100],
        },
        window: {
          width: 0,
        },
      },
      text: "",
      theaderclass: ["theadcolor"],
      apiPredictList: (data) =>
        this.userRequest.post("/API/Default/PredictList", data),
    };
  },
  mounted() {
    // this.object.table.totalRows = this.object.table.items.length;
  },
  computed: {
    totalData() {
      return this.object.table.items.length;
    },
    ifstacked() {
      return this.object.window.width <= 750;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.init();
    // this.$emit("update", this.object);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  props: ["data"],
  methods: {
    init() {
      this.FunctionToken(this.getPredictList, {});
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.object.table.totalRows = filteredItems.length;
      this.object.table.currentPage = 1;
    },
    getPredictList(data) {
      this.apiPredictList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let list = JSON.parse(json.Data);
            list.forEach((x) => {
              x.ifshow = false;
              this.object.table.allitems.push(x);
            });
            //this.object.table.allitems = JSON.parse(json.Data);
            this.object.table.list1 = this.object.table.allitems.filter(
              (x) => x.CATEGORY == "雜糧"
            );
            this.object.table.list2 = this.object.table.allitems.filter(
              (x) => x.CATEGORY == "果品"
            );
            this.object.table.list3 = this.object.table.allitems.filter(
              (x) => x.CATEGORY == "蔬菜"
            );
            this.object.table.list4 = this.object.table.allitems.filter(
              (x) => x.CATEGORY == "切花"
            );
            this.object.table.items = JSON.parse(json.Data);
            this.object.table.totalRows = this.object.table.items.length;
            this.object.table.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    changeCategory(index) {
      if (index == 0) this.object.table.items = this.object.table.list1;
      if (index == 1) this.object.table.items = this.object.table.list2;
      if (index == 2) this.object.table.items = this.object.table.list3;
      if (index == 3) this.object.table.items = this.object.table.list4;
    },
    parseDate(date) {
      let subdate = date.split(" ")[0].split("/");
      subdate[0] = parseInt(subdate[0]) - 1911;
      return subdate.join("/");
    },
    showdescription(item) {
      if (item.ifshow) return item.DESCRIBE;

      return item.DESCRIBE.substr(0, 50);
    },
    handleResize() {
      this.object.window.width = window.innerWidth;
    },
    linkClick(val) {
      val.ifshow = !val.ifshow;
      this.$refs.croptable.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.white-text-btn {
  color: rgb(255, 255, 255);
  margin-right: 0.5em;
  border: none !important;
  display: inline-block;

  &.blue {
    background-color: rgb(22, 155, 213);
  }

  &.orange {
    background-color: rgb(245, 154, 35);
  }

  &.green {
    background-color: rgb(112, 182, 3);
  }

  &.purple {
    background-color: rgb(194, 128, 255);
  }
}

.farminput {
  max-width: 13rem;
  display: inline-block;
}

.text-box {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.theadcolor {
  background-color: #28a745 !important;
  color: #ffffff !important;
}
</style>
